"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BuildingIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.903.5c0-.276.226-.5.505-.5h8.087c.279 0 .505.224.505.5V16h-2.88v-3.75a.251.251 0 00-.254-.25H9.34a.251.251 0 00-.252.25V16H1V5.5c0-.276.226-.5.505-.5h4.398V.5zM9.339 4a.251.251 0 00-.252.25v2.5c0 .138.113.25.252.25h2.527c.14 0 .253-.112.253-.25v-2.5a.251.251 0 00-.253-.25H9.34zm-.252 4.25c0-.138.113-.25.252-.25h2.527c.14 0 .253.112.253.25v2.5c0 .138-.113.25-.253.25H9.34a.251.251 0 01-.252-.25v-2.5z",
    clipRule: "evenodd"
  })))
});
BuildingIcon.displayName = 'BuildingIcon';
var _default = exports.default = BuildingIcon;